import React from "react";
import { useState,useEffect } from "react";
import YesNoContainer from "../YesNoContainer/YesNoContainer";
import PenPunContainer from "../PenPunContainer/PenPunContainer";

const GeneralAddictionBody = ({id,question,image,penalty,punishment}) => {

    const [contentId,setContentId] = useState("yesNoContainer");
    const [user,setUser] = useState(null);
    const [bearerToken,setBearerToken] = useState(null);

    useEffect(()=>{

    },[user,bearerToken])

    const styles={
        addictionBody:{
            width:"100%",
            height:"100%",
            textAlign:"center",
        }
    }

    const contents = {
        yesNoContainer:<YesNoContainer id={id} image={image} question={question} setContentId={setContentId} setUser={setUser} setBearerToken={setBearerToken}></YesNoContainer>,
        penPunContainer:<PenPunContainer id={id} penalty={penalty} punishment={punishment} setContentId={setContentId} incomingUser={user} bearerToken={bearerToken}></PenPunContainer>
    }

    return <div id="addiction-body" style={styles.addictionBody}>
        {contents[contentId] || <div>Component not found!</div>}
    </div>
}

export default GeneralAddictionBody;